import React, { useState, useEffect } from 'react';
import api from '../../services/api';

const FormworkEfficiency = () => {
  const [data, setData] = useState({ by_element: [], by_foreman: [] });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await api.get('/analytics/formwork-efficiency');
      setData(response.data);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching formwork efficiency:', error);
      setLoading(false);
    }
  };

  if (loading) return <div className="loading">Loading formwork efficiency...</div>;

  return (
    <div className="formwork-efficiency">
      <div className="card">
        <h3>Formwork Efficiency by Element</h3>
        {data.by_element.length > 0 ? (
          <table>
            <thead>
              <tr>
                <th>Element</th>
                <th>Category</th>
                <th>Total Logs</th>
                <th>Plywood Reused</th>
                <th>Reuse Rate</th>
              </tr>
            </thead>
            <tbody>
              {data.by_element.map((item, idx) => (
                <tr key={idx}>
                  <td>{item.element_detail}</td>
                  <td>{item.element_category}</td>
                  <td>{item.total_logs}</td>
                  <td>{item.plywood_reused}</td>
                  <td><strong>{item.reuse_rate_percent}%</strong></td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p>No formwork efficiency data available yet.</p>
        )}
      </div>

      <div className="card">
        <h3>Formwork Efficiency by Foreman</h3>
        {data.by_foreman.length > 0 ? (
          <table>
            <thead>
              <tr>
                <th>Foreman</th>
                <th>Total Logs</th>
                <th>Plywood Reused</th>
                <th>Reuse Rate</th>
              </tr>
            </thead>
            <tbody>
              {data.by_foreman.map((item, idx) => (
                <tr key={idx}>
                  <td>{item.foreman}</td>
                  <td>{item.total_logs}</td>
                  <td>{item.plywood_reused}</td>
                  <td><strong>{item.reuse_rate_percent}%</strong></td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p>No formwork efficiency data available yet.</p>
        )}
      </div>
    </div>
  );
};

export default FormworkEfficiency;